//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import couponVideo from '@/components/cardCoupons/component/couponVideo'
export default {
  name: "couponSwiper",
  components:{
      couponVideo
  },
  props: {
    banners:Array
  },
  data(){
    return{
        dataImgItem:[],
        options5: {
            controls: true,
            muted: true,
            poster: ''
        },
    }
  },
  mounted() {
    this.$store.commit('UPDATE_HEAD',false);
    this.$store.commit('UPDATE_FOOTER',false);
    console.log(this.playerOptions)
    this.dataImgItem = this.banners.map((item) => {
        if (item.type === 0) {
            return item;
        } else {
            // item.url = [{
            //     src: item.url,
            //     type: "video/mp4"
            // }];
            // item.options5 = { ...this.options5, poster: item.cover };
            // this.initVideo(item)
            return item;
        }
    })
    },
    methods:{
        initVideo(item){
            console.log(item.cover)
            let videoPoster = item.cover
            this.playerOptions.poster = videoPoster
            this.playerOptions.sources[0].src = item.url
            console.log(this.playerOptions)
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/cardCoupons/component/couponSwiper.vue